<template>
  <!--<label>-->
  <div class="new-moudle cf-qq-components">
    <!-- 情况一 qq可编辑状态 -->
    <div class="cf-qq-compedit">
      <label>
        <div class="user-info-item">
          <div class="new-moudle cf-order-addqq">
            <slot name="avatar"></slot>
            <!-- 企鹅小图标 输入时隐藏 -->
            <template v-if="isProvideUinEditable">
              <i class="cf-order-qqicon"></i>
              <input
                v-model="provideDisplayName"
                v-focus="hasInputFocus"
                class="mod-account-edit__input cf-order-inputqq"
                type="tel"
                :readonly="isInputUinReadOnly"
                :disabled="
                  (isQQConnectLoginState && currentItem.categoryId == 1) ||
                  provideAccountType == 'WX' ||
                  (loginState.sessionId == 'uin' && currentItem.categoryId == 1 && currentItem.currency_type != 2)
                "
                :placeholder="provideUinPlaceHolder"
                maxlength="11"
                @input="changeProvideUin"
                @click="popSelectFriends"
                @blur="provideUinPlaceHolderFocusStatus = false"
              />
              <i
                v-show="provideAccountType == 'QQ' && provideUin && provideUinNickname && !isInputUinInvalid"
                class="cf-order-qqinfo mod-account-edit__tips tips"
                >{{ provideUinNickname }}</i
              >
            </template>
            <i v-else class="mod-account-edit__input cf-icon-q cf-order-inputqq">{{ provideDisplayName }}</i>

            <!-- 展示时图标 -->
            <i
              v-show="
                provideUin &&
                isProvideUinEditable &&
                provideAccountType == 'QQ' &&
                provideDisplayName &&
                currentItem.categoryId != 1 &&
                !userAgent.QQ
              "
              class="new-moudle mod-account-edit__icon i_clear"
              role="button"
              aria-label="删除文本栏输入"
              @click.stop.prevent="clearProvideUin"
            ></i>
            <i
              v-show="!provideUin && isProvideUinEditable && currentItem.categoryId != 1 && !hasInputFocus && provideAccountType == 'QQ'"
              class="mod-account-edit__icon cf-order-editicon"
              aria-label="点击编辑QQ号码"
            ></i>
          </div>
        </div>
        <p v-show="provideAccountType == 'QQ' && provideUin && isProvideUinModified" class="new-moudle cf-order-qqwarn tips warn">
          请核对以上QQ号，不要充错号码哦！
        </p>
      </label>
    </div>
    <!-- 情况三  好友列表 -->
    <FriendsSelector
      :avatar="avatar"
      :is-shown="showSelectFriends"
      :on-select-self="selectSelf"
      :on-select-friends="selectFriends"
      :self-nick-name="mqqUserInfo.nick"
    ></FriendsSelector>
  </div>
  <!--</label>-->
</template>
<script>
import * as enums from "../../../store/enums"
import { mapGetters, mapActions } from "vuex"
import Raven from "raven-js"
import * as langs from "../../../constants/langs"
import * as reportDict from "../../../constants/report-dictonary"
import FriendsSelector from "../../common/FriendsSelector.vue"

export default {
  directives: {
    focus: {
      update: (el, { value }) => {
        if (value) {
          el.focus()
        }
      }
    }
  },
  props: ["getZoneInfo"],

  computed: {
    ...mapGetters([
      "isProvideUinEditable",
      "provideAccountType",
      "loginState",
      "currentItem",
      "isQQConnectLoginState",
      "userAgent",
      "provideUinNickname",
      "avatar",
      "qqConnectNickname"
    ]),
    isInputUinReadOnly() {
      return (
        this.provideAccountType == "WX" ||
        (this.loginState.sessionId == "uin" &&
          this.currentItem.categoryId == enums.BUSINESS_TYPE.MOBILE_GAME &&
          this.currentItem.currency_type != 2) ||
        (this.userAgent.QQ && !(this.currentItem.categoryId == enums.BUSINESS_TYPE.MONTH && this.userAgent.android)) //手Q上只有安卓包月可以输入，其他都不能输入
      )
    },
    provideDisplayName: {
      get() {
        if (this.provideAccountType == "QQ") {
          if (
            langs.QQ_CONNECT_SESSION_TYPE.indexOf(this.loginState.sessionType) > -1 &&
            this.currentItem.categoryId == enums.BUSINESS_TYPE.MOBILE_GAME
          ) {
            return this.$store.getters.userNickname
          } else {
            return this.$store.getters.provideUin
          }
        } else if (this.provideAccountType == "WX") {
          return this.wechatNickname || `${this.currentItem.categoryId == enums.BUSINESS_TYPE.MOBILE_GAME ? "安卓|" : ""}微信帐户`
        }
      },
      set(value) {
        this.$store.dispatch("changeProvideUin", value)
      }
    },
    provideUinPlaceHolder: {
      get() {
        if (this.isQQConnectLoginState && !this.userAgent.weixin && !this.provideUinPlaceHolderFocusStatus) {
          return this.qqConnectNickname
        } else {
          return "请输入充值号码"
        }
      }
    },
    provideUin: {
      get() {
        return this.$store.getters.provideUin
      },
      set(value) {
        this.$store.dispatch("changeProvideUin", value)
      }
    }
  },

  components: {
    FriendsSelector
  },

  data() {
    return {
      hasInputFocus: false,
      provideUinPlaceHolderFocusStatus: false,
      isInputUinInvalid: false,
      showSelectFriends: false,
      mqqUserInfo: "",
      uinInputTimer: null,
      isProvideUinModified: false
    }
  },

  methods: {
    ...mapActions(["getMqqUserInfo", "selectMqqContact", "setProvideNickname"]),
    editProvideUin() {
      this.hasInputFocus = true
    },
    clearProvideUin() {
      this.hasInputFocus = false
      this.getZoneInfo("")
      this.$store.dispatch("clearProvideUin")
    },
    changeFocusStatus(status) {
      this.reportUserAction({
        iformat: reportDict.CLICK.CHANGE_ORDER_PROVIDEUIN_NEW,
        pfStructure: this.$route.query.pfStructure
      })

      this.hasInputFocus = status
      this.provideUinPlaceHolderFocusStatus = status
    },
    changeProvideUin(e) {
      clearTimeout(this.uinInputTimer)
      let uin = e.target.value
      uin = uin.replace(/^0/, "").replace(/\D*/gi, "")

      this.provideUin = uin
      this.isProvideUinModified = true

      this.uinInputTimer = setTimeout(
        uin => {
          if (/^[1-9]{1}[0-9]{4,10}$/.test(uin)) {
            this.getZoneInfo(uin)

            this.$store.dispatch("getQQNickname", uin)
            this.isInputUinInvalid = false
          } else {
            this.isInputUinInvalid = true
          }
        },
        1500,
        uin
      )
    },
    popSelectFriends() {
      // 如果是iframe框内，则屏蔽赠送
      if (top !== self) {
        return false
      }
      // iap包月支付只能给自己买
      if (this.userAgent.QQ && !(this.userAgent.iOS && this.currentItem.categoryId == enums.BUSINESS_TYPE.MONTH)) {
        this.showSelectFriends = !this.showSelectFriends
        this.getMqqUserInfo().then(result => {
          this.mqqUserInfo = result
        })
      }
      this.provideUinPlaceHolderFocusStatus = true
    },
    selectSelf() {
      this.$store.dispatch("changeProvideUin", this.loginState.openid)
      this.$store.dispatch("getQQNickname", this.loginState.openid)
      this.showSelectFriends = false
      this.isInputUinInvalid = false

      this.getZoneInfo(this.loginState.openid)
    },
    selectFriends() {
      if (this.userAgent.QQ) {
        return this.selectMqqContact()
          .then(res => {
            this.showSelectFriends = false
            this.provideUin = res.uin
            this.getZoneInfo(res.uin)
            this.setProvideNickname(res.name)
            this.isInputUinInvalid = false
          })
          .catch(e => {
            Raven.captureBreadcrumb({
              message: "select-qq-friends-failure",
              category: "user",
              data: {
                e
              }
            })
          })
      }
    }
  }
}
</script>
